/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React, { useEffect } from 'react';

const Testimonials = () => {
  useEffect(() => {
    const swiperCtor = window.Swiper;
    if (!swiperCtor || !document.getElementById('testimonial')) return;

    const swiper = new swiperCtor('#testimonial', {
      slidesPerView: 1,
      pagination: { el: '#testimonial .swiper-pagination', clickable: true }
    });

    return () => swiper.destroy?.(true, true);
  }, []);

  return (
    <div id="tf-testimonials" className="text-center">
      <div className="overlay">
        <div className="container">
          <div className="section-title center">
            <h2><strong>Testimonials</strong></h2>
            <div className="line"><hr /></div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div id="testimonial" className="swiper">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <h5>&quot;Pizza Hut is keen to implement affordable energy-saving tools such as NoWatt, and works with AECOM to achieve this.&quot;</h5>
                    <p><strong>Raefe Watkin-Rees</strong>, Commercial Director, Pizza Hut (UK) Ltd.</p>
                  </div>
                  <div className="swiper-slide">
                    <h5>&quot;NoWatt helps us to make educated decisions on which energy reduction projects will provide the greatest financial benefits.&quot;</h5>
                    <p><strong>Richard Felgate</strong>, Head of Energy Management, Mitchells &amp; Butlers</p>
                  </div>
                  <div className="swiper-slide">
                    <h5>&quot;The information from ECA and NoWatt is spot on, and essential for clubs like us.&quot;</h5>
                    <p><strong>Steve Hicks</strong>, Head of Estates, Sheffield United Football Club</p>
                  </div>
                </div>
                <div className="swiper-pagination" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
